import React from 'react';
import { Card } from './ui/card';
import { Mail, Phone, MapPin, Linkedin, Github } from 'lucide-react';
import { portfolioData } from '../data/mock';

const Contact = () => {
  const { personal } = portfolioData;

  return (
    <section id="contact" className="py-20 bg-slate-900 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 right-10 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-10 w-72 h-72 bg-blue-600/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Get In <span className="text-blue-400">Touch</span>
          </h2>
          <div className="w-20 h-1 bg-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Open to roles in Pune, Mumbai, or Bangalore. Let's discuss how I can help elevate your quality assurance strategy.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex justify-center">
            {/* Contact Info */}
            <Card className="bg-slate-800/50 border-slate-700 p-8 w-full max-w-2xl">
              <h3 className="text-2xl font-semibold text-white mb-6 text-center">Contact Information</h3>
              <div className="space-y-4">
                <a
                  href={`mailto:${personal.email}`}
                  className="flex items-center gap-4 p-4 hover:bg-blue-600/10 rounded-lg transition-colors group"
                >
                  <div className="p-3 bg-blue-600/20 rounded-lg group-hover:bg-blue-600/30 transition-colors">
                    <Mail className="text-blue-400" size={24} />
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 mb-1">Email</p>
                    <p className="text-base text-white break-all">{personal.email}</p>
                  </div>
                </a>

                <a
                  href={`tel:${personal.phone}`}
                  className="flex items-center gap-4 p-4 hover:bg-blue-600/10 rounded-lg transition-colors group"
                >
                  <div className="p-3 bg-blue-600/20 rounded-lg group-hover:bg-blue-600/30 transition-colors">
                    <Phone className="text-blue-400" size={24} />
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 mb-1">Phone</p>
                    <p className="text-base text-white">{personal.phone}</p>
                  </div>
                </a>

                <div className="flex items-center gap-4 p-4">
                  <div className="p-3 bg-blue-600/20 rounded-lg">
                    <MapPin className="text-blue-400" size={24} />
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 mb-1">Location</p>
                    <p className="text-base text-white">{personal.location}</p>
                  </div>
                </div>
              </div>

              {/* Social Links */}
              <div className="mt-8 pt-6 border-t border-slate-700">
                <p className="text-sm text-gray-400 mb-4 text-center">Connect with me</p>
                <div className="flex gap-4 justify-center">
                  <a
                    href={personal.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-4 bg-slate-900/50 hover:bg-blue-600/20 border border-slate-700 hover:border-blue-500 rounded-lg text-gray-400 hover:text-blue-400 transition-all duration-300 hover:scale-110"
                    aria-label="LinkedIn"
                  >
                    <Linkedin size={24} />
                  </a>
                  <a
                    href={personal.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-4 bg-slate-900/50 hover:bg-blue-600/20 border border-slate-700 hover:border-blue-500 rounded-lg text-gray-400 hover:text-blue-400 transition-all duration-300 hover:scale-110"
                    aria-label="GitHub"
                  >
                    <Github size={24} />
                  </a>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
